import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import { GridComponent, TooltipComponent, LegendComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import {  Card } from 'react-bootstrap'; 
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex'; 
// Enregistrement des composants nécessaires d'ECharts
echarts.use([LineChart, GridComponent, TooltipComponent, LegendComponent, CanvasRenderer]);


const formatCurrency = (value) => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};


const ChartCA = ({ data }) => { 
    // const getRevenueOption = (data) => {
    //     const dates = data.map((item) => item.date); // Extraire les dates
    //     const cumulativeRevenues = data.map((item) => item.cumulativeRevenue); // Chiffre d'affaires cumulé
      
    //     return {
    //       tooltip: {
    //         trigger: 'axis',
    //         formatter: (params) => {
    //           const [{ axisValue, data }] = params;
    //           return `
    //             <strong>${axisValue}</strong><br />
    //             Chiffre d'affaires cumulé : ${formatCurrency(data)}
    //           `;
    //         },
    //       },
    //       xAxis: {
    //         type: 'category',
    //         data: dates,
    //         axisLabel: {
    //           rotate: 45,
    //           interval: 3,
    //         },
    //       },
    //       yAxis: {
    //         type: 'value',
    //         name: 'Chiffre d\'affaires (€)',
    //         axisLabel: {
    //           formatter: (value) => formatCurrency(value),
    //         },
    //       },
    //       series: [
    //         {
    //           name: 'Chiffre d\'affaires',
    //           type: 'line',
    //           data: cumulativeRevenues,
    //           smooth: true,
    //           lineStyle: {
    //             color: '#5470C6',
    //             width: 2,
    //           },
    //           itemStyle: {
    //             color: '#5470C6',
    //           },
    //         },
    //       ],
    //       grid: { right: '0px', left: '100px', bottom: '20%', top: '10%' }
        
    //     };
    //   };
    const getRevenueAndCommissionOption = (data) => {
        const dates = data.map((item) => item.date);
        const cumulativeRevenues = data.map((item) => item.cumulativeRevenue);
        const cumulativeCommissions = data.map((item) => item.cumulativeCommission);
      
        return {
          tooltip: {
            trigger: 'axis',
            formatter: (params) => {
              const [revenue, commission] = params;
              return `
                <strong>${revenue.axisValue}</strong><br />
                Chiffre d'affaires cumulé : ${formatCurrency(revenue.data)}<br />
                Commissions cumulées : ${formatCurrency(commission.data)}
              `;
            },
          },
          legend: {
            data: ['Chiffre d\'affaires', 'Commissions'],
          },
          xAxis: {
            type: 'category',
            data: dates,
            axisLabel: {
              rotate: 45,
              interval: 3,
            },
          },
          yAxis: {
            type: 'value',
            name: 'Montant (€)',
            axisLabel: {
              formatter: (value) => formatCurrency(value),
            },
          },
          series: [
            {
              name: 'Chiffre d\'affaires',
              type: 'line',
              data: cumulativeRevenues,
              smooth: true,
              lineStyle: {
                color: '#5470C6',
                width: 2,
              },
              itemStyle: {
                color: '#5470C6',
              },
            },
            {
              name: 'Commissions',
              type: 'line',
              data: cumulativeCommissions,
              smooth: true,
              lineStyle: {
                color: '#91CC75',
                width: 2,
              },
              itemStyle: {
                color: '#91CC75',
              },
            },
          ],
        };
      };
  return (
    <Card className="h-100">
      <FalconCardHeader
        title="Chiffre d'affaires / Date de confirmation pour l'année"
        titleTag="h6"
        className="py-2"
        light
        endEl={
          <Flex>
            {/* <Button variant="link" size="sm" as={Link} className="me-2" to="#!">
              View Details
            </Button>
            <CardDropdown /> */}
          </Flex>
        }
      />
      <Card.Body className="h-100">
        <ReactEChartsCore
        echarts={echarts}
        option={getRevenueAndCommissionOption(data)}
        style={{ height: '100%', minHeight: '17.75rem' }}
      />
      </Card.Body>
    </Card> 
  );
};

export default ChartCA;